function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 54 45.2"
}, props), React.createElement("g", {
  fill: "none",
  stroke: "currentColor"
}, React.createElement("path", {
  strokeMiterlimit: "10",
  strokeWidth: ".5",
  strokeLinecap: "round",
  className: styles["2da64d5a0b48978b1c832ad37fbd04ee__st0"] || "2da64d5a0b48978b1c832ad37fbd04ee__st0",
  d: "M5.4 1.6l.9.9M4.1 3.6h1.6m-.3 2.1l.9-.9m1.3 2.1V5.3m0-3.5V.3m2.1 5.4l-.8-.8m2.2-1.3H9.6m.1-2l-.8.9m34.4 5.1l.9.9M42 9.6h1.6m-.3 2.1l.9-.9m1.2 2v-1.6m0-3.4V6.2m2.2 5.5l-.9-.9M49 9.6h-1.6m.2-2l-.9.9m1.4 31.2l.9.9m-2.2 1h1.6m-.3 2.1l.9-.9m1.2 2.1v-1.6m0-3.5v-1.6m2.2 5.5l-.9-.9m2.3-1.2h-1.6m.2-1.9l-.9.9M1.6 37.5l.9.9M.3 39.5h1.6m-.3 2.1l.9-.9m1.3 2v-1.6m0-3.4v-1.6m2.1 5.5l-.9-.9m2.3-1.2H5.7m.2-2l-.9.9"
}), React.createElement("path", {
  strokeLinejoin: "round",
  strokeLinecap: "round",
  d: "M27.7 7.8c1 .8 6.1 6 5.8 17-1.9 1.4-4.2 2.2-6.5 2.2 0 0 .6 0 0 0-3.2-.1-5.8-2.1-5.8-2.1-.3-11 5.3-16.2 6.3-17-.1-.1.1-.2.2-.1z"
}), React.createElement("path", {
  strokeLinejoin: "round",
  strokeLinecap: "round",
  d: "M21.4 22.2s5.6 3.5 11.9 0m-10 5.3l-2.5 5 5.8-2.3 1.1 3.7s.1.1.1 0l1.1-3.7 5.8 2.3-2.5-5m-12-9.7s-1.7 4-.6 7.8c-.4 1.2-1.3 1.4-1.3 1.4s-3-6 1.9-9.2zm14.4 0s1.7 4 .6 7.8c.4 1.2 1.3 1.4 1.3 1.4s2.9-6-1.9-9.2zm-9.8 17.5l-1.6 3.2 3.7-1.5.7 2.4h.1l.7-2.4 3.7 1.5-1.6-3.2"
}), React.createElement("circle", {
  strokeLinejoin: "round",
  strokeLinecap: "round",
  cx: "27.6",
  cy: "17.4",
  r: "2.9"
}))));